var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 40,
    viewBox: "0 0 29 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13.956C0 14.0657 0.0215363 14.669 0.0215363 14.6751C0.578404 26.0684 14.0909 40 14.0909 40C14.0909 40 27.6034 26.0715 28.1603 14.6751V14.666C28.1664 14.5654 28.1818 14.0657 28.1818 13.956C28.1818 6.24667 21.8717 0 14.0909 0C6.31014 0 0 6.24667 0 13.956ZM6.60242 13.956C6.60242 9.85754 9.95593 6.53615 14.0909 6.53615C18.2259 6.53615 21.5794 9.85754 21.5794 13.956C21.5794 18.0544 18.2259 21.3727 14.0909 21.3727C9.95593 21.3727 6.60242 18.0513 6.60242 13.956Z",
    fill: "#FF3154"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.1818,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.175b7076c02f85c6d21c4397ffb4dfac.svg";
export { ForwardRef as ReactComponent };